// @flow

export type Environment = {
    name: string,
    backendBaseURL: string,
    mpProject: string,
};


const environments = {
    de: {
        backendBaseURL: 'https://api.eu-central-1.tvsmiles.tv',
        mpProject: 'd0fe02115e2aaf31a693c162d9fa62c4',
    },
};


export default function getEnvironment(name: string): Environment {
    return Object.assign({}, environments[name], { name });
}



// WEBPACK FOOTER //
// ./src/lib/getEnvironment.jsx